<template>
    <div>
      <h1 class="text-success">Establecimientos de Salud</h1>
      <div class="alert alert-info" role="alert">
      <strong>Nota:</strong> Estas opciones de establecimiento de salud se agregaran al listado de todos los formularios.
    </div>
      <div class="mt-4">
        <button @click="showCreateForm" class="btn btn-primary">Agregar Establecimiento de Salud</button>
      </div>
  
      <!-- Lista de establecimientos de salud en una tabla -->
      <div class="table-responsive mt-3">
  <table class="table table-bordered">
    <thead class="thead-light">
      <tr>
        <th>Nombre del Establecimiento</th>
        <th>Acciones</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="establecimiento in establecimientos" :key="establecimiento._id">
        <td>{{ establecimiento.nombre }}</td>
        <td>
          <div class="btn-group" role="group">
            <button @click="editEstablecimiento(establecimiento)" class="btn btn-warning btn-sm">Editar</button>
            <button @click="deleteEstablecimiento(establecimiento._id)" class="btn btn-danger btn-sm">Eliminar</button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
  
      <!-- Formulario de creación/editar -->
      <div v-if="showForm" class="mt-4">
  <h2 class="h4">{{ isEditing ? 'Editar Establecimiento de Salud' : 'Agregar Establecimiento de Salud' }}</h2>
  <form @submit.prevent="isEditing ? updateEstablecimientoSalud() : createEstablecimientoSalud()" class="form-inline">
    <div class="form-group mr-2">
      <label for="nombre" class="mr-2">Nombre del Establecimiento</label>
      <input v-model="formData.nombre" type="text" id="nombre" required class="form-control form-control-lg" />
    </div>
    <div class="btn-group">
      <button type="submit" class="btn btn-primary">{{ isEditing ? 'Guardar Cambios' : 'Agregar' }}</button>
      <button @click="cancelEdit" class="btn btn-secondary">Cancelar</button>
    </div>
  </form>
</div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import swal from 'sweetalert';
  import { BASE_URL } from '../store/config';
  
  export default {
    computed: {
      currentUser() {
        return this.$store.state.auth.user;
      },
    },
    data() {
      return {
        establecimientos: [],
        showForm: false,
        formData: {
          nombre: '',
        },
        isEditing: false,
        editingEstablecimientoId: null,
      };
    },
    methods: {
      async fetchEstablecimientos() {
        try {
          const response = await axios.get(`${BASE_URL}/api/establecimiento`, {
            headers: {
              'x-access-token': this.$store.state.auth.user.accessToken,
            },
          });
          this.establecimientos = response.data;
        } catch (error) {
          console.error('Error al obtener establecimientos de salud:', error);
        }
      },
      showCreateForm() {
        this.showForm = true;
        this.isEditing = false;
        this.formData = {
          nombre: '',
        };
      },
      async createEstablecimientoSalud() {
        try {
          await axios.post(`${BASE_URL}/api/establecimiento`, this.formData, {
            headers: {
              'x-access-token': this.$store.state.auth.user.accessToken,
            },
          });
          swal({
            title: '¡Información Guardada!',
            text: 'La información de Establecimiento de Salud ha sido guardada correctamente.',
            icon: 'success',
            button: 'OK',
          });
          this.limpiarCampos();
          this.fetchEstablecimientos();
          this.showForm = false;
        } catch (error) {
          swal({
            title: 'Error',
            text: `Hubo un error al guardar la información del establecimiento de salud. \n ${error.response.data.message}.`,
            icon: 'error',
            button: 'OK',
          });
        }
      },
      limpiarCampos() {
        this.formData = {
          nombre: '',
        };
      },
      deleteEstablecimiento(id) {
        swal({
          title: '¿Estás seguro?',
          text: 'Una vez eliminado, no podrás recuperar este registro.',
          icon: 'warning',
          buttons: ['Cancelar', 'Eliminar'],
          dangerMode: true,
        })
        .then((confirmacion) => {
          if (confirmacion) {
            this.realizarEliminacionEstablecimiento(id);
          }
        });
      },
      async realizarEliminacionEstablecimiento(id) {
        try {
          await axios.delete(`${BASE_URL}/api/establecimiento/${id}`, {
            headers: {
              'x-access-token': this.$store.state.auth.user.accessToken,
            },
          });
          swal({
            title: '¡Información Eliminada!',
            text: 'La información de Establecimiento de Salud ha sido eliminada correctamente.',
            icon: 'success',
            button: 'OK',
          });
          this.fetchEstablecimientos();
        } catch (error) {
          swal({
            title: 'Error',
            text: 'Hubo un error al eliminar la información del establecimiento de salud.',
            icon: 'error',
            button: 'OK',
          });
        }
      },
      editEstablecimiento(establecimiento) {
        this.isEditing = true;
        this.editingEstablecimientoId = establecimiento._id;
        this.formData.nombre = establecimiento.nombre;
        this.showForm = true;
      },
      async updateEstablecimientoSalud() {
        try {
          await axios.put(`${BASE_URL}/api/establecimiento/${this.editingEstablecimientoId}`, this.formData, {
            headers: {
              'x-access-token': this.$store.state.auth.user.accessToken,
            },
          });
          swal({
            title: '¡Información Actualizada!',
            text: 'La información de Establecimiento de Salud ha sido actualizada correctamente.',
            icon: 'success',
            button: 'OK',
          });
          this.limpiarCampos();
          this.fetchEstablecimientos();
          this.showForm = false;
        } catch (error) {
          swal({
            title: 'Error',
            text: `Hubo un error al editar la información del establecimiento de salud. \n ${error.response.data.message}.`,
            icon: 'error',
            button: 'OK',
          });
        }
      },
      cancelEdit() {
        this.showForm = false;
        this.isEditing = false;
        this.formData = {
          nombre: '',
        };
      },
    },
    mounted() {
      this.fetchEstablecimientos();
    },
  };
  </script>
  
  <style scoped>
  </style>
  